import { slugToMatch } from "@/utils/slug";

export const defaultSeo = {
  title: "Oh Yes Home Solution kerala |Deep Cleaning & Repairs",
  description:
    "Oh Yes Home Solutions offers deep cleaning, AC installation, uninstallation, service, repair, and jet wash services in Kerala by verified technicians.",
};

export const pageSeo = {
  home: {
    title: defaultSeo.title,
    description: defaultSeo.description,
  },
  about: {
    title: "Oh Yes About Us | Expert Home Services Across Kerala",
    description:
      "Oh Yes offers trusted and affordable home service across Kerala. Discover our mission, expert team, and commitment to quality service for every home.",
  },
  services: {
    title: "Oh Yes Services - Trusted Home Service Experts",
    description:
      "Explore Oh Yes World's AC repair, cleaning, plumbing & electrical services. Book trusted experts online for fast, reliable home solutions today.",
  },
  blog: {
    title: "Oh Yes Blog - Home Service Tips & Expert Guides",
    description:
      "Read the Oh Yes blog for home service tips, maintenance guides, and expert advice on AC, cleaning, plumbing, and electrical services. Stay informed.",
  },
  news: {
    title: "Latest News & Updates | Oh Yes Home Services",
    description:
      "Stay updated with the latest news, service updates, offers, and announcements from Oh Yes World. Explore trends in home services.",
  },
  us: {
    home: {
      title: "Oh Yes Home Services Illinois | Trusted Home Service Professionals",
      description:
        "Book trusted home services across Illinois. Find professionals for cleaning, handyman, plumbing, electrical, HVAC, painting, appliance repair, and more with Oh Yes.",
    },
    about: {
      title: "About Oh Yes Home Services | Serving Homes Across Illinois",
      description:
        "Learn about Oh Yes Home Services and our mission to connect Illinois homeowners with trusted professionals for cleaning, repairs, maintenance, and home improvement services.",
    },
    services: {
      title: "Home Services in Illinois | Cleaning, Handyman, Plumbing & More",
      description:
        "Explore professional home services across Illinois including home cleaning, handyman services, plumbing, electrical, HVAC, painting, appliance repair, and home maintenance.",
    },
    news: {
      title: "USA News Coming Soon | Oh Yes Illinois",
      description:
        "Oh Yes Home Services news and updates for the USA are coming soon.",
    },
  },
};

const serviceSeoItems = [
  {
    keywords: ["ac", "air-conditioner", "air conditioner"],
    title: "Oh Yes AC Service - Fast and Trusted Professionals",
    description:
      "Book trusted AC repair, installation & maintenance with Oh Yes World. Skilled technicians, easy online booking & reliable support at your doorstep.",
  },
  {
    keywords: ["cleaning", "deep-cleaning", "deep cleaning", "pest"],
    title: "Oh Yes Cleaning Service - Safe & Trusted Expert",
    description:
      "Oh Yes World offers safe, trusted home, office & deep cleaning by professionals. Book online easily for a clean, healthy space at affordable prices.",
  },
  {
    keywords: ["plumbing", "plumber"],
    title: "Oh Yes – Expert Plumbing Services in Kerala",
    description:
      "Oh Yes provides reliable pipe repair, leak fixing & plumbing installation. Book trusted plumbers online for quick, hassle-free service at your door.",
  },
  {
    keywords: ["electrical", "electrician", "electric"],
    title: "Oh Yes Electrical Services - Quick & Trusted Help",
    description:
      "Oh Yes offers trusted electrical wiring, repair & installation. Book certified electricians online for safe, reliable service at your doorstep.",
  },
  {
    keywords: ["appliance", "washing-machine", "fridge", "refrigerator"],
    title: "Oh Yes Appliance Repair - Expert Repairing & Services",
    description:
      "Get expert appliance repair services with Oh Yes. Washing machine, fridge, and home appliance repair by trusted technicians. Book service easily online.",
  },
  {
    keywords: ["painting", "painter"],
    title: "Oh Yes Painting Service - Professional Painters",
    description:
      "Oh Yes offers professional home & office painting by skilled painters. Book trusted experts online for quality, clean finishing at affordable prices.",
  },
  {
    keywords: ["interior", "interiors", "designer", "designers"],
    title: "Oh Yes Interior - Trusted Home Designers",
    description:
      "Oh Yes offers trusted interior design by expert home designers. Get modern, stylish & functional living spaces. Book interior services online today.",
  },
  {
    keywords: ["garden", "gardening", "landscaping", "lawn"],
    title: "Oh Yes Garden Services - Garden Design Expert",
    description:
      "Oh Yes provides trusted garden services with expert lawn care, landscaping, and garden design. Book professional gardeners for a beautiful outdoor space.",
  },
  {
    keywords: ["construction", "builder", "builders", "home-builder"],
    title: "Oh Yes Construction Service - Build Your Dream Home",
    description:
      "Oh Yes offers trusted interior design by expert home designers. Get modern, stylish & functional living spaces. Book interior services online today.",
  },
  {
    keywords: ["water-purifier", "water purifier", "ro"],
    title: "Oh Yes – Water Purifier Repair & Service Expert",
    description:
      "Oh Yes offers trusted RO repair, installation & maintenance. Book expert water purifier services for clean, safe drinking water at home or office.",
  },
];

function normalize(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[_/]+/g, "-")
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function getServiceSeo(value) {
  const normalized = normalize(slugToMatch(decodeURIComponent(value || "")));

  return (
    serviceSeoItems.find((item) =>
      item.keywords.some((keyword) => normalized.includes(normalize(keyword))),
    ) || null
  );
}

export function resolveSeo(to) {
  const metaSeo =
    typeof to.meta?.seo === "function" ? to.meta.seo(to) : to.meta?.seo;

  if (metaSeo) {
    return metaSeo;
  }

  return defaultSeo;
}

const indiaOrganizationSchema = {
  "@type": "HomeAndConstructionBusiness",
  "@id": "https://ohyesworld.com/#organization",
  name: "Oh Yes Home Solutions",
  url: "https://ohyesworld.com/",
  logo: "https://ohyesworld.com/icons/icon-512.png",
  image: "https://ohyesworld.com/icons/icon-512.png",
  description:
    "Trusted home services in Kerala including cleaning, AC service, plumbing, electrical, appliance repair, painting, interiors, home builders, and water purifier service.",
  telephone: "+91-7356449135",
  email: "support@ohyesworld.com",
  priceRange: "Affordable",
  areaServed: {
    "@type": "AdministrativeArea",
    name: "Kerala",
  },
  sameAs: [
    "https://play.google.com/store/apps/details?id=com.ohyes.app",
    "https://apps.apple.com/in/app/oh-yes-home-solution/id6471665769",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Oh Yes Home Services",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "AC repair, installation and maintenance",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Cleaning and pest control",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Plumbing repair and installation",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Electrical wiring, repair and installation",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Painting, interiors, home builders and water purifier service",
        },
      },
    ],
  },
};

const usOrganizationSchema = {
  "@type": "HomeAndConstructionBusiness",
  "@id": "https://ohyesworld.com/us#organization",
  name: "Oh Yes Home Services Illinois",
  url: "https://ohyesworld.com/us",
  logo: "https://ohyesworld.com/icons/icon-512.png",
  image: "https://ohyesworld.com/icons/icon-512.png",
  description: pageSeo.us.home.description,
  email: "support@ohyesworld.com",
  priceRange: "Affordable",
  areaServed: {
    "@type": "AdministrativeArea",
    name: "Illinois",
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Oh Yes Home Services Illinois",
    itemListElement: [
      "Cleaning",
      "Handyman services",
      "Plumbing",
      "Electrical",
      "HVAC",
      "Painting",
      "Appliance repair",
      "Home maintenance",
    ].map((name) => ({
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name,
      },
    })),
  },
};

const usHomeFaqSchema = {
  "@type": "FAQPage",
  "@id": "https://ohyesworld.com/us#faq",
  mainEntity: [
    {
      "@type": "Question",
      name: "What areas do you serve?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "We proudly provide home services across Illinois, including Chicago and surrounding communities. Service availability may vary by location and service category. Please contact us directly to confirm availability in your area.",
      },
    },
  ],
};

function getRouteUrl(to) {
  const path = to?.path || "/";
  return `https://ohyesworld.com${path === "/" ? "/" : path}`;
}

export function resolveSchema(to) {
  const isUsRoute = to?.meta?.location === "us" || to?.path?.startsWith("/us");
  const seo = resolveSeo(to);
  const routeUrl = getRouteUrl(to);
  const websiteId = isUsRoute
    ? "https://ohyesworld.com/us#website"
    : "https://ohyesworld.com/#website";
  const organizationId = isUsRoute
    ? "https://ohyesworld.com/us#organization"
    : "https://ohyesworld.com/#organization";

  const graph = [
    {
      "@type": "WebSite",
      "@id": websiteId,
      url: isUsRoute ? "https://ohyesworld.com/us" : "https://ohyesworld.com/",
      name: seo.title,
      description: seo.description,
      publisher: {
        "@id": organizationId,
      },
      inLanguage: isUsRoute ? "en-US" : "en-IN",
    },
    isUsRoute ? usOrganizationSchema : indiaOrganizationSchema,
    {
      "@type": "WebPage",
      "@id": `${routeUrl}#webpage`,
      url: routeUrl,
      name: seo.title,
      description: seo.description,
      isPartOf: {
        "@id": websiteId,
      },
      about: {
        "@id": organizationId,
      },
      inLanguage: isUsRoute ? "en-US" : "en-IN",
    },
  ];

  if (to?.path === "/us") {
    graph.push(usHomeFaqSchema);
  }

  return {
    "@context": "https://schema.org",
    "@graph": graph,
  };
}
